import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import GENERAL from 'utils/constants/general';

const { ENV } = GENERAL;

function WarehousesList(props) {
	const { routes, history, modeView } = props;

	if (
		history.location.pathname === ENV.ROUTES.PATHS.WAREHOUSES_MANAGE &&
		modeView === 'cards'
	)
		return <Redirect to={ENV.ROUTES.PATHS.WAREHOUSES_MANAGE_MOBILE} />;
	else if (
		history.location.pathname === ENV.ROUTES.PATHS.WAREHOUSES_MANAGE &&
		modeView === 'table'
	)
		return <Redirect to={ENV.ROUTES.PATHS.WAREHOUSES_MANAGE_DESKTOP} />;

	return (
		<div className='animated fadeIn'>
			{routes.map((route, i) => {
				return (
					<Route
						key={i}
						path={route.path}
						render={oProps => (
							<route.component {...oProps} {...props} routes={route.routes} />
						)}
					/>
				);
			})}
		</div>
	);
}

export default WarehousesList;
